import { useTokenStore } from '@/src/common/store/useTokenStore'
import { useCallback } from 'react'
import { useAlert } from '@/src/components/ui/elements/dialogs/useAlert'
import { useApolloClient } from '@apollo/client'
import { useUserStore } from '@/src/common/store/useUserStore'
import { GET_USER_INFO } from '@/src/common/gql/queries/user'
import { resetSegmentUser } from '@/src/services/segment'
import { router } from 'expo-router'
import { Routes } from '@/src/common/enums/routes'

export function useSignout() {
  const Alert = useAlert(useSignout.name)
  const { clearTokens } = useTokenStore()
  const client = useApolloClient()
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  const { setUserInformation } = useUserStore()

  return useCallback(
    () =>
      Alert.alert('Sign Out', 'Are you sure you want to sign out?', [
        {
          text: 'No',
          style: 'cancel',
        },
        {
          text: 'Yes',
          style: 'destructive',
          onPress() {
            clearTokens()
            client.cache.updateQuery({ query: GET_USER_INFO }, () => undefined)
            setUserInformation(undefined)
            void resetSegmentUser()
            router.replace(Routes.Root.route)
          },
        },
      ]),
    [clearTokens, Alert, setUserInformation, client],
  )
}
